export const GET_LIST_DIMENSIONS_WATCHER =
  "app/ReportsV2/WidgetListDimensions/GET_LIST_DIMENSIONS_WATCHER"
export const GET_LIST_DIMENSIONS_SUCCESS =
  "app/ReportsV2/WidgetListDimensions/GET_LIST_DIMENSIONS_SUCCESS"
export const GET_LIST_DIMENSIONS_FAILED =
  "app/ReportsV2/WidgetListDimensions/GET_LIST_DIMENSIONS_FAILED"
